import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import PeopleIcon from "@mui/icons-material/People";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import SettingsIcon from "@mui/icons-material/Settings";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import TuneIcon from "@mui/icons-material/Tune";
import AssignmentIcon from "@mui/icons-material/Assignment";

export const superAdminLinks = [
  {
    id: 1,
    text: "Dashboard",
    path: "/admindashboard",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    text: "Suppliers",
    path: "/suppliermanagement",
    icon: <PersonIcon />,
  },
  {
    id: 3,
    text: "Job",
    path: "/jobs",
    icon: <PostAddIcon />,
  },
  {
    id: 4,
    text: "Skill",
    path: "/skills",
    icon: <PlaylistAddIcon />,
  },
  {
    id: 5,
    text: "Clients",
    path: "/clients",
    icon: <SupervisorAccountIcon />,
  },
  {
    id: 6,
    text: "CV Search",
    path: "/cv_search",
    icon: <ManageSearchIcon />,
  },
  {
    id: 7,
    text: "Search Config",
    path: "/cv_search_config",
    icon: <TuneIcon />,
  },
  {
    id: 8,
    text: "Interview Tracking",
    path: "/interview_info",
    icon: <RecordVoiceOverIcon />,
  },
  {
    id: 9,
    text: "Candidate",
    path: "/candidate_data",
    icon: <PeopleIcon />,
  },
  {
    id: 13,
    text: "Offer Management",
    path: "/offermanagement",
    icon: <AssignmentTurnedInIcon />,
  },
  {
    id: 10,
    text: "Support",
    path: "/support",
    icon: <HelpOutlineIcon />,
  },
  {
    id: 11,
    text: "Analytics",
    path: "/analytics",
    icon: <AnalyticsIcon />,
  },
  {
    id: 12,
    text: "Settings",
    path: "/settings",
    icon: <SettingsIcon />,
  },
  {
    id: 13,
    text: "Pipeline Config",
    path: "/pipeline-config",
    icon: <SettingsIcon />,
  },
  {
    id: 14,
    text: "Headcount & Requisition",
    path: "/requisitions",
    icon: <AssignmentIcon />,
  },
];

export const userLinks = [
  {
    id: 1,
    text: "Dashboard",
    path: "/supplierdashboard",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    text: "Candidate",
    path: "/candidate_data",
    icon: <PeopleIcon />,
  },
  {
    id: 3,
    text: "CV Search",
    path: "/cv_search",
    icon: <ManageSearchIcon />,
  },
  {
    id: 4,
    text: "Support",
    path: "/support",
    icon: <HelpOutlineIcon />,
  },
];
